/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import isArray from 'lodash.isarray';
import {createParameters, CreateQueryParams, createSearchFilters, normalize} from './Query';
import {Query} from './types';

export const generatePlatformsQuery = (query: keyof Query, {
  fields, search
}: CreateQueryParams): string => {
  const newline = ',\n';
  let isNumberArray = false;
  Object.entries(search?.filter)?.forEach(([prop, value]) => {
    if (isArray(value)) {
      isNumberArray = prop === 'deviceId';
    }
  });

  let document  = '{';
  if (search) {
    document += `
      ${query}(${createSearchFilters(search, true, isNumberArray)}) {
        platforms {
          ${normalize(fields, newline)}
        }
      }`;
  } else {
    document += `
      ${query} {
        ${normalize(fields, newline)}
      }`;
  }
  document += '}';
  return document;
};

export const generateAssetQuery = (
  query: keyof Query,
  {fields, search, args: {page = 1, perPage = 10}}: CreateQueryParams
): string => {
  const newline = ',\n';
  let isNumberArray = false;
  Object.entries(search?.filter)?.forEach(([prop, value]) => {
    if (isArray(value)) {
      isNumberArray = prop === 'id';
    }
  });

  const queryBody = search
    ? `
      ${query}(filter: {${createParameters(search?.filter, isNumberArray)}}, page: ${page}, perPage: ${perPage}) {
        items { ${normalize(fields, newline)} }
      }`
    : `
      ${query} {
        ${normalize(fields, newline)}
      }`;

  return `{
    ${queryBody}
  }`;
};
